import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { SessionService } from '../services/session.service';
import { AppRoutes } from '@ciptech/constants'

@Injectable()
export class ClientsGuard implements CanActivate {

	constructor(private session: SessionService, private router: Router) { }

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
		const isClient = !!this.session.user?.clientId;
		if (!isClient) {
			this.router.navigate([AppRoutes.SIGN_IN], { queryParams: { returnUrl: state.url } });
		}

		return isClient;
	}
}
